import {
  Route,
  Routes
} from "react-router-dom";
import { Overview } from './Overview';
import { AddShop } from './Add';
import { EditShop } from './Edit';

export const ShopRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/edit/:id" element={<EditShop />} />
      <Route path="/add" element={<AddShop />} />
      <Route path="/" element={ <Overview /> } />
    </Routes>
  );
}
